// src/components/common/audio-player/session/useRegisterAudioSession.ts

"use client";
import { useEffect, useId } from "react";
import { audioSession } from "./AudioSession";

export function useRegisterAudioSession(audioRef: React.RefObject<HTMLAudioElement | null>) {
  const id = useId();

  useEffect(() => {
    return () => {
      audioSession.detach(id);
    };
  }, [id]);

  return id;
}